import React, { PureComponent } from "react";
import { Redirect, Link } from "react-router-dom";
import {
    Button,
    Row,
    Col,
    Input,
    Form,
    Alert,
    message,
    Skeleton,
    Space,
    Select,
    Spin,
    Table,
    DatePicker,
    Modal,
    Radio
} from "antd";
import "@ant-design/compatible/assets/index.css";

import Config from "../../../Config"

import { connect } from "react-redux";
import { setConfig, ajaxHandler, ajaxViewHandler } from "../../../store/actions";

import "antd/dist/antd.css";
// import TambahKota from "./TambahKota";
// import EditKota from "./EditKota";
import moment from 'moment';
import DetailKantor from "./DetailKantor";

var configClass = {
    apiUrl: {
        data: "/api/v1.0/pusat/e-service/kantor-cabang",
    },
};
const itemCari = {
    nama_perusahaan: "Nama Perusahaan",
    nama_kepala_cabang: "Nama Kepala Cabang",
};

class DaftarKantor extends PureComponent {
    config;
    timeoutGetQr;
    timeOutPushQr;
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.config = new Config();
        this.state = {

            modalTambahVisible: false,
            modalEditVisible: false,
            selectedDataEdit: null,
            errMsg: "",
            loadingData: false,
            pagination: { pageSize: 15 },
            confirmDelete: false,
            searchText: "",
            searchColumn: "",
            showDetailError: false,
            dataSource: [],
            columns: [
                {
                    title: "Nama Kepala Cabang",
                    dataIndex: "nama_kepala_cabang",
                    key: "nama_kepala_cabang",
                },
                {
                    title: "Pelabuhan",
                    dataIndex: "nama_pelabuhan",
                    key: "nama_pelabuhan",
                },
                {
                    title: "Propinsi",
                    dataIndex: "nama_propinsi",
                    key: "nama_propinsi",
                },
                {
                    title: "Alamat",
                    dataIndex: "alamat",
                    key: "alamat",
                },
                {
                    title: "Details",
                    width: 80,
                    dataIndex: "perush",
                    key: "perush",
                    align: "center",
                    render: (value, row, index) => {
                        return (
                            <>
                                <a href="javascript:;"
                                    className="btn btn-info btn-sm pr-1 pl-1 round white"
                                    title="Kantor Cabang Detail"
                                    onClick={() => this.detailData(row)}
                                >
                                    <i className="la la-pencil white"></i>
                                </a>
                            </>
                        );
                    }
                },

            ],
            dataDetail: null,
            filter: "",
            filterUmum: "",
        };
    }


    UNSAFE_componentWillMount() { }

    async componentDidMount() {
        await this.getData(this.state.pagination.pageSize, 1);
    }

    componentDidUpdate(prevProps) { }

    detailData = (row) => {
        // console.log("row " + row);

        var content = <DetailKantor id={row.kc_id} />
        // console.log("content " + content);
        this.tabProses(
            {
                title: "Detail Kantor",
                key: "detail_kantor",
                content: content
            }
        );

        setTimeout(() => {
            this.props.setConfig({
                id: row.kc_id,
            })
        }, 300);

    };

    handleTglChange = (val) => {
        const formattedDate = moment(val).format('YYYY-MM-DD');
        // console.log(formattedDate); // Output: 2023-06-06
        this.setState({
            filterTgl: val ? "&tanggal=" + formattedDate : ""
        })
    }

    removeTab = targetKey => {
        // console.log("masuk sini")
        var tempTabs = this.props.tabs;
        const index_cari = tempTabs.findIndex((data) => data.key == targetKey);
        var activeKey = "";
        if (index_cari != -1) {
            activeKey = tempTabs[index_cari - 1].key
            tempTabs.splice(index_cari, 1);
        }
        // alert(activeKey);
        this.props.setConfig({
            tabs: tempTabs,
            activeKey: activeKey
        });
    };

    tabProses(tabData) {
        const key = tabData.key;
        var tempTabs = this.props.tabs;
        var isExist = false;
        tempTabs.map((item) => {
            if (item.key == key) {
                isExist = true;
            }
        });
        if (isExist) {
            this.props.setConfig({
                activeKey: tabData.key,
            });
        } else {
            tempTabs = [
                ...tempTabs,
                {
                    title: tabData.title,
                    content: tabData.content,
                    key: tabData.key,
                },
            ];
            this.props.setConfig({
                tabs: tempTabs,
                activeKey: tabData.key,
            });
        }
    }

    async getData(limit = this.state.pagination.pageSize, offset = 1) {
        this.setState({
            loadingData: true,
            errTitle: "",
            errMsg: "",
            showDetailError: false,
            dataSource: []
        });
        // console.log("get", configClass.apiUrl.data +
        //     "?limit=" +
        //     limit +
        //     "&page=" +
        //     offset + this.state.filter);
        console.log(this.state.filter)

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.data +
                "?limit=" +
                limit +
                "&page=" +
                offset + this.state.filter)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pagination = { ...this.state.pagination };
                    pagination.total = data.responseData.attributes.total;
                    this.setState({
                        dataSource: data.responseData.items,
                        pagination,
                    });
                } else {
                    const errTitle = "failed get data";
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg,
                    });
                    message.error({ content: errTitle, duration: 2, key: "toast" });
                }
                this.setState({ loadingData: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                message.error({
                    content: "gagal request data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
                this.setState({ loadingData: false });
            });
    }

    handleSelectOption = (val) => {
        this.setState({
            filterUmum: "&" + val + "=",
        })
        // console.log(val);
    }

    filterData(values) {
        const { filterUmum, filterTgl } = this.state;
        var filter = "";
        var kataKunci = "";
        for (var key in values) {
            if (values[key] != undefined) {
                if (key == 'keyword') {
                    kataKunci = values[key];
                }
            }
        }
        if(values.keyword && !values.items)
            this.setState({modal_pengumuman : true})
        else{
            if(filterTgl != undefined)
            filter = filterUmum + kataKunci+ filterTgl ;
            else filter = filterUmum + kataKunci ;
            this.setState({
                filter: filter,
                pagination: { pageSize: 15, current: 1 },
            }, () => {
                this.getData(this.state.pagination.pageSize, 1)
            });
        }
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pagination };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingData: true,
            pagination,
        });
        if (pagination.current == 1) {
            this.getData(pagination.pageSize);
        } else {
            this.getData(
                pagination.pageSize,
                pagination.current
                // (pagination.current - 1) * pagination.pageSize
            );
        }
    };

    handleClear() {
        this.setState({
            filter: "",
            filterUmum: "",
            filterTgl: "",
        }, () => {
            this.formRef.current.resetFields();
            this.getData(this.state.pagination.pageSize, 1);
        });
    }

    render() {
        return (
            <>

                {/*<!-- Tab Content -->*/}
                <div className="row tab-content">
                    {/*<!-- Tab Beranda -->*/}

                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-tittle">Pencarian</h4>
                                        <a className="heading-elements-toggle">
                                            <i className="la la-ellipsis-v font-medium-3"></i>
                                        </a>
                                        <div className="heading-elements">
                                            <ul className="list-inline mb-0">
                                                <li>
                                                    <a data-action="expand">
                                                        <i className="ft-maximize"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a data-action="collapse">
                                                        <i className="ft-plus"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body p-0">
                                            <div className="form-body">
                                                <Form
                                                    size="large"
                                                    onFinish={(values) => this.filterData(values)}
                                                    className="form form-horizontal striped-rows form-bordered"
                                                    ref={this.formRef}
                                                >
                                                    <div className="row p-2">
                                                        <div className="col-lg-6">
                                                            <div className="form-group row mx-auto">
                                                                <label className="col-md-4 label-control">
                                                                    Kata Kunci Pencarian{" "}
                                                                </label>
                                                                <div className="col-md-8">
                                                                    <Form.Item
                                                                        name="keyword"
                                                                    >
                                                                        <Input
                                                                            type="text"
                                                                            id="keyword"
                                                                            className="form-control"
                                                                            placeholder="Kata kunci pencarian"
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                            <div className="form-group row mx-auto">
                                                                <label className="col-md-4 label-control">
                                                                    Cari Berdasarkan{" "}
                                                                </label>
                                                                <div className="col-md-8">
                                                                    <Form.Item name="items">
                                                                        <Select
                                                                            onChange={this.handleSelectOption}
                                                                            placeholder={"Pilih items pencarian"}>
                                                                            {Object.entries(itemCari).map(([value, label]) => (
                                                                                <Select.Option
                                                                                    value={value}
                                                                                    key={value}
                                                                                >
                                                                                    {label}
                                                                                </Select.Option>
                                                                            ))}

                                                                        </Select>
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                            <div className="form-group row mx-auto">
                                                                <label className="col-md-4 label-control">
                                                                    Tanggal Surat Keluar{" "}
                                                                </label>
                                                                <div className="col-md-8">
                                                                    <Form.Item name="tgl_rpk">
                                                                        <DatePicker
                                                                            format="DD-MM-YYYY"
                                                                            onChange={this.handleTglChange}
                                                                        />
                                                                    </Form.Item>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    <div className="row m-2">
                                                        <Space>
                                                            {/* <div className="col-lg-12 text-center"> */}
                                                            <button type="submit" id="btnCari" className="btn grey btn-sm btn-info round">Cari</button>
                                                            <button type="button" onClick={() => this.handleClear()} className="btn btn-sm btn-secondary round ml-1">Clear</button>
                                                            {/* </div> */}
                                                        </Space>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12" id="berkas">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-content collapse show">
                                        <div className="card-body">
                                            {(this.state.errMsg != null && this.state.errMsg != "" &&
                                                <Alert
                                                    message={this.state.errTitle}
                                                    description={
                                                        <div>
                                                            {this.state.showDetailError == true
                                                                ?
                                                                JSON.stringify(this.state.errMsg)
                                                                :
                                                                "gagal mendapatkan response server, cobalah beberapa saat lagi"
                                                            }
                                                        </div>
                                                    }
                                                    // description={JSON.stringify(this.state.errMsg)}
                                                    type="error"
                                                    showIcon
                                                    closable
                                                    style={{
                                                        marginBottom: 10,
                                                    }}
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary" onClick={() => this.getData(this.state.pagination.pageSize, 1)}>
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                danger
                                                                type="ghost"
                                                                onClick={() => {
                                                                    const recentValue = this.state.showDetailError;
                                                                    this.setState({
                                                                        showDetailError: !recentValue
                                                                    })
                                                                }}
                                                            >
                                                                {this.state.showDetailError == true ? "Hide Error Detail" : "Show Error Detail"}
                                                            </Button>
                                                        </Space>
                                                    }
                                                />
                                            )}
                                            <div className="table-responsive">
                                                <Table
                                                    // style={{margin: 10}}
                                                    title={() => (
                                                        <Row>
                                                            <Col lg={8} sm={24} xs={24}>
                                                                <span className="konten-judul">
                                                                    Total {this.state.pagination.total} record
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    rowKey="permohonan_id"
                                                    bordered
                                                    columns={this.state.columns}
                                                    dataSource={this.state.dataSource}
                                                    loading={this.state.loadingData}
                                                    // scroll={{ x: 500, y: 600 }}
                                                    size="small"
                                                    pagination={this.state.pagination}
                                                    onChange={this.handleTableChange}
                                                    className="table table-bordered table-striped mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<!-- end berkas -->*/}
                    </div>
                    {/*<!-- End Tab Beranda -->*/}

                    <Modal
                        zIndex={10000}
                        width={"25%"}
                        title={
                        <h4 className="modal-title text-bold-500 white">
                            Warning
                        </h4>
                        }
                        visible={this.state.modal_pengumuman}
                        onCancel={() => {
                        this.setState({
                            modal_pengumuman: false,
                        });
                        }}
                        footer={[
                        <button
                            key="btn-keluar-jenis"
                            type="button"
                            className="btn btn-sm grey btn-danger round mr-1"
                            data-dismiss="modal"
                            onClick={() => {
                            this.setState({
                                modal_pengumuman: false,
                            });
                            }}
                        >
                            Tutup
                        </button>,
                        ]}
                    >
                        <div className="row">
                            <div className="col-lg-12">
                            <div className="form-group row mx-auto last">
                                <label className="col-md-12 label-control">Untuk melakukan pencarian dengan kata kunci, isian Cari Berdasarkan harus dipilih</label>
                            </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                {/*<!-- End Tab Beranda -->*/}
            </>
        );
    }
}

const mapStateToProps = function (state) {
    return state.configReducers;
};

export default connect(mapStateToProps, {
    setConfig,
    ajaxHandler,
    ajaxViewHandler,
})(DaftarKantor);
